import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { CardHeader } from '@mui/material';

export const FlexTextContainer = styled(Box)({
  minWidth: 0,
  whiteSpace: 'normal',
  overflowWrap: 'break-word',
});

export const ZeroMinWidthCardHeader = styled(CardHeader)({
  '& .MuiCardHeader-content': {
    minWidth: 0,
  },
});
